export default "__VITE_ASSET__SIhprirKpoi1x8GdHTYWvQ__"